<div class="fsTable scoreboard mat-elevation-z8">
    <div class="fsTable_header scoreboard_header">
        <div class="fsTable_cell-head scoreboard_cell-name">
            {{ 'DASHBOARD.TOP_TEAMS' | translate }}
        </div>
        <div class="fsTable_cell-head scoreboard_cell-matches">
            {{ 'DASHBOARD.MATCHES' | translate }}
        </div>
        <div class="fsTable_cell-head scoreboard_cell-winsPerc">
            {{ 'DASHBOARD.WINS_PERCENT' | translate }}
        </div>
        <div class="fsTable_cell-head scoreboard_cell-wins">{{ 'DASHBOARD.POINTS' | translate }}</div>
    </div>
    @if (items?.length) {
        <div class="box-wrapper scrollbar" id="style-5" [style.max-height.px]="height">
            @for (t of items; track t; let ix = $index) {
                <div class="fsTable_line scoreboard_line" [class.first]="ix === 0" [class.second]="ix === 1" [class.third]="ix === 2">
                    <div class="fsTable_cell scoreboard_cell-name">
                        @if (!t.namedTeamName) {
                            <span>{{ ix + 1 }}. {{ t.player1 }} - {{ t.player2 }}</span>
                        }
                        @if (t.namedTeamName) {
                            <span [matTooltip]="t.player1 + ' - ' + t.player2">{{ ix + 1 }}. {{ t.namedTeamName }}</span>
                        }
                    </div>
                    <div class="fsTable_cell scoreboard_cell-matches">{{ t.winsCount }} / {{ t.matchesCount }}</div>
                    <div class="fsTable_cell scoreboard_cell-wins">
                        {{ t.winPercentage }}
                    </div>
                    <div
                        class="fsTable_cell scoreboard_cell-winsPerc"
                        [matTooltip]="t.pointsAvarage | number: '1.0-5' : 'cs'"
                        matTooltipPosition="above"
                        matTooltipTouchGestures="off"
                    >
                        {{ t.pointsAvarage | number: '1.0-2' }}
                    </div>
                </div>
            }
            @for (t of notQualified; track t) {
                <div
                    [matTooltip]="'DASHBOARD.MATCHBOX_TRESHOLD' | translate: { threshold: t.remainsForQualification }"
                    class="fsTable_line scoreboard_line text-muted"
                    matTooltipTouchGestures="off"
                >
                    <div class="fsTable_cell scoreboard_cell-name text-decoration-line-through">
                        @if (!t.namedTeamName) {
                            <span>{{ t.player1 }} - {{ t.player2 }}</span>
                        }
                        @if (t.namedTeamName) {
                            <span [matTooltip]="t.player1 + ' - ' + t.player2">{{ t.namedTeamName }}</span>
                        }
                    </div>
                    <div class="fsTable_cell scoreboard_cell-matches">{{ t.winsCount }} / {{ t.matchesCount }}</div>
                    <div class="fsTable_cell scoreboard_cell-wins">
                        {{ t.winPercentage }}
                    </div>
                    <div
                        class="fsTable_cell scoreboard_cell-winsPerc"
                        [matTooltip]="t.pointsAvarage | number: '1.0-5' : 'cs'"
                        matTooltipPosition="above"
                    >
                        {{ t.pointsAvarage | number: '1.0-2' }}
                    </div>
                </div>
            }
        </div>
    } @else {
        @if (items && items.length === 0) {
            <div class="d-flex flex-column justify-content-center align-items-center empty-message">
                <h3>{{ 'DASHBOARD.EMPTY_TEAMS_SCOREBOARD' | translate }}</h3>
            </div>
        }
    }
</div>
